type LinkType = {
  _type?: string;
};

const predefinedLinkTypes = Object.freeze([
  'instagram',
  'youtube',
  'spotify',
  'bandcamp',
  'facebook',
  'x',
  'soundcloud',
  'tiktok',
]);

const matchers: Record<string, (url: string) => boolean> = {
  instagram: url => url.includes('instagram.com'),
  youtube: url => url.includes('youtube.com') || url.includes('youtu.be'),
  spotify: url => url.includes('spotify.com'),
  bandcamp: url => url.includes('bandcamp.com'),
  facebook: url => url.includes('facebook.com') || url.includes('fb.com'),
  x: url => url.includes('twitter.com') || url.includes('x.com'),
  soundcloud: url => url.includes('soundcloud.com'),
  tiktok: url => url.includes('tiktok.com'),
};

export const normalizeArtistLinks = <T extends { url: string }>(links: T[]): (T & LinkType)[] => {
  const output: (T & LinkType)[] = [];

  for (const link of links) {
    if (!link.url) {
      continue;
    }

    const match = predefinedLinkTypes.find(t => matchers[t]?.(link.url)) || 'website';
    output.push({ ...link, _type: match });
  }

  return output;
};
